const MOBILE_BREAKPOINT = 991;

if (!customElements.get('product-layout')) {
  customElements.define(
    'product-layout',
    class ProductLayout extends HTMLElement {
      constructor() {
        super();

        this.sidebarContainer = this.querySelector(
          '#product-layout-sidebar-container'
        );
        this.sidebarMobileContainer = this.querySelector(
          '#product-layout-mobile-information-container'
        );
        this.bottomContainer = document.querySelector('main');
        this.productInformationBlocks = this.querySelector(
          '[data-product-information-blocks]'
        );
        this.breadcrumbs = this.querySelector('[data-breadcrumbs]');
        this.bottomContentElements = this.querySelectorAll(
          '[data-product-bottom-content]'
        );

        this.mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);
        this.isMobile = this.mql.matches;
        this.handleMQChange = (e) => {
          const nowMobile = e.matches;
          if (nowMobile !== this.isMobile) {
            this.isMobile = nowMobile;
            this.checkElementsToMove();
          }
        };
      }

      connectedCallback() {
        this.init();
        this.checkElementsToMove();

        this.mql.addEventListener?.('change', this.handleMQChange) ||
          this.mql.addListener?.(this.handleMQChange); // old Safari fallback
      }

      disconnectedCallback() {
        this.mql.removeEventListener?.('change', this.handleMQChange) ||
          this.mql.removeListener?.(this.handleMQChange);
      }

      init() {
        if (this.breadcrumbs) this.prepend(this.breadcrumbs);

        if (this.bottomContainer) {
          this.bottomContentElements.forEach((el) =>
            this.bottomContainer.appendChild(el)
          );
        } else {
          console.warn(
            'Target container not found for bottom content elements.'
          );
        }
      }

      reinstateQuantityInput() {
        const quantityInput = this.querySelector('quantity-input');
        if (quantityInput) {
          quantityInput.dispatchEvent(new CustomEvent('movedDOM'));
        }
      }

      checkElementsToMove() {
        if (this.isMobile) {
          if (this.sidebarMobileContainer && this.productInformationBlocks) {
            this.reinstateQuantityInput();
            this.sidebarMobileContainer.appendChild(
              this.productInformationBlocks
            );
          } else if (!this.sidebarMobileContainer) {
            console.warn(
              'Target container not found for product-information-blocks (mobile).'
            );
          }
        } else {
          if (this.sidebarContainer && this.productInformationBlocks) {
            this.reinstateQuantityInput();
            this.sidebarContainer.appendChild(this.productInformationBlocks);
          } else if (!this.sidebarContainer) {
            console.warn(
              'Target container not found for product-information-blocks (desktop).'
            );
          }
        }
      }
    }
  );
}
